import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { PostalCodeComponent } from './postal-code.component';

@NgModule({
    declarations: [PostalCodeComponent],
    imports: [FormsModule, MatFormFieldModule, MatInputModule, MatSelectModule, TranslateModule],
    exports: [PostalCodeComponent],
})
export class PostalCodeModule {}
